import axios from 'axios';

import { config } from '../../../config/env';
import { OabEligibility, Profession } from './types';

const baseUrl = config.jusfyBackend.apiUrl;
const eligibilityUrl = `${baseUrl}/oab/eligibility`;
const professionUrl = `${baseUrl}/oab/profession`;

type OabEligibilityResponse = {
  is_eligible: boolean;
  has_oab: boolean;
  profession: Profession | null;
  should_show_banner: boolean;
};

export async function getOabEligibility(): Promise<OabEligibility> {
  const { data } = await axios.get<OabEligibilityResponse>(eligibilityUrl);

  return {
    isEligible: data.is_eligible,
    hasOab: data.has_oab,
    profession: data.profession,
    shouldShowBanner: data.should_show_banner,
  };
}

export async function updateProfession(profession: Profession): Promise<void> {
  await axios.patch<void>(professionUrl, { profession });
}
